import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AutopilotLevel, Frac } from '~lmo/models/frac.model';
import { LmoFracModalService } from '~lmo/services/lmo-frac-modal.service';
import { LmoFracsService } from '~lmo/services/lmo-fracs.service';
import { UserService } from '~services/user.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-frac-autopilot-engage',
  styleUrls: ['./lmo-frac-autopilot-engage.component.scss'],
  templateUrl: './lmo-frac-autopilot-engage.component.html',
})
export class LmoFracAutopilotEngageComponent implements OnInit {
  public desiredLevel$$ = new BehaviorSubject<AutopilotLevel>(null);
  public activeNetworkRequest$$ = new BehaviorSubject<boolean>(false);
  public activeNetworkRequest$ = this.activeNetworkRequest$$.asObservable();
  public currentFrac$: Observable<Frac>;
  public isSemiAuto$: Observable<boolean>;
  public isFullAuto$: Observable<boolean>;
  public isShaleApps = this.userService.isShaleappsEmail();
  public isSemiDesired$ = this.desiredLevel$$.asObservable().pipe(map((level) => level === 'semi'));
  public isFullDesired$ = this.desiredLevel$$.asObservable().pipe(map((level) => level === 'full'));
  constructor(
    private userService: UserService,
    private fracService: LmoFracsService,
    private lmoModal: LmoFracModalService,
  ) {}

  public ngOnInit() {
    this.currentFrac$ = this.fracService.currentFrac$;
    this.isSemiAuto$ = this.currentFrac$.pipe(map((frac) => frac.account.maxAutopilotLevel === 'semi'));
    this.isFullAuto$ = this.currentFrac$.pipe(map((frac) => frac.account.maxAutopilotLevel === 'full'));
  }

  public updateStatus(level: AutopilotLevel) {
    this.desiredLevel$$.next(level);
    this.activeNetworkRequest$$.next(true);
    this.fracService.changeAutopilotLevelForCurrentFrac$(level).subscribe((response) => {
      this.activeNetworkRequest$$.next(false);
      if (response) {
        this.lmoModal.closeHomeModal();
      }
    });
  }
}
